import React, { useState } from "react";
import {
  Title,
  GoBack,
  TextArea,
  MyMessage,
  InputField,
  MyActionButton,
} from "../../component/Component";
import { useStaticContext } from "../../../../context/static/StaticContext";
import { getOneService } from "../../../../middlewares/sysNavigation/SysNavigation";

const Edit = () => {
  const { updateStaticContent } = useStaticContext();
  const footer = getOneService();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const service_id = footer.service_id;
  const [title, setTitle] = useState(footer.title);
  const [description, setDescription] = useState(footer.description);
  const footerRoutes = "/service";

  const responses = (error, message) => {
    setError(error);
    setSuccess(!error);
    setErrorMessage(message);
  };

  const updateOneFooterHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  /**
   * @author Ntavigwa Bashombe
   * @param {*} thumbnail
   * @returns
   */
  const sendDBRequest = async () => {
    const data = {
      title: title,
      description: description,
    };

    const { status, message } = await updateStaticContent(
      "service",
      service_id,
      data
    );
    if (status === 200) responses(false, message);
    else responses(true, status, message);
  };

  return (
    // Keep original scrolling/height behavior to avoid overflow regressions
    <div className="p-4 h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <div className="mx-auto w-full max-w-5xl">
        {/* Top row */}
        <div className="mb-3 flex items-center justify-between">
          <GoBack props={{ route: footerRoutes }} />
        </div>

        {/* Alerts */}
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />

        {/* Header card */}
        <div className="mb-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <Title props={{ title: "Service Details" }} />
              <p className="mt-1 text-[11px] text-gray-500">
                Keep the title clear and the description concise.
              </p>
            </div>
            <span className="inline-flex items-center gap-2 rounded-full bg-gray-50 px-3 py-1 text-[11px] font-medium ring-1 ring-gray-200">
              <span
                className={[
                  "h-1.5 w-1.5 rounded-full",
                  loading ? "bg-amber-500" : success ? "bg-emerald-500" : "bg-gray-300",
                ].join(" ")}
              />
              {loading ? "Saving…" : success ? "Saved" : "Editing"}
            </span>
          </div>
        </div>

        <form onSubmit={updateOneFooterHandler}>
          {/* Content card */}
          <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
            <div className="grid grid-cols-1 gap-4 p-4">
              {/* Title field */}
              <div className="rounded-lg border bg-gray-50/60 p-3 hover:bg-gray-50">
                <InputField
                  props={{
                    id: "title",
                    title: "Title",
                    type: "text",
                    value: title ? title : "",
                    onChange: (e) => {
                      setTitle(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
              </div>

              {/* Description field */}
              <div className="rounded-lg border bg-gray-50/60 p-3 hover:bg-gray-50">
                <TextArea
                  props={{
                    id: "description",
                    title: "Description",
                    type: "text",
                    value: description ? description : "",
                    rows: 8,
                    onChange: (e) => {
                      setDescription(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <p className="mt-2 text-[11px] text-gray-500">
                  Aim for 120–160 characters for best readability.
                </p>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="mt-4 flex items-center justify-end">
            <MyActionButton
              title="Save Changes"
              loading={loading}
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage(null);
              }}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Edit;
